import { useMemo } from 'react';
import { GuestProfile } from '@mews-commander/guest-profile';
import { createZodFormResolver, useFormControls } from '@mews/framework';
import { FieldsGridProps } from '../components';
import { createZodSchema, FormValues, MergeFormSchema } from '../schema';
import { usePreSelectedInitialValues } from './usePreSelectedInitialValues';

interface ConflictingFieldsFormControlsProps extends Pick<FieldsGridProps, 'preSelectedFields'> {
    leftProfile: GuestProfile;
    rightProfile: GuestProfile;
    targetId: string;
    handleMerge: (mergeData: MergeFormSchema) => void;
}

export const useConflictingFieldsFormControls = ({
    preSelectedFields,
    leftProfile,
    rightProfile,
    targetId,
    handleMerge,
}: ConflictingFieldsFormControlsProps) => {
    const preSelectedFieldsNames = useMemo(
        () => preSelectedFields.map((preSelectedField) => preSelectedField.field),
        [preSelectedFields]
    );

    const schema = useMemo(() => createZodSchema(preSelectedFieldsNames), [preSelectedFieldsNames]);

    const resolver = useMemo(() => createZodFormResolver<FormValues>(schema), [schema]);

    const initialValues = usePreSelectedInitialValues({ preSelectedFields, leftProfile, rightProfile });

    const defaultValues = useMemo(() => initialValues, [initialValues]);

    const submitHandler = (formValues: FormValues) => {
        const mergeData = {
            targetId,
            ...(preSelectedFields.length ? { guestProfileDetails: formValues } : null),
        };
        handleMerge(mergeData);
    };

    const { renderFormContent, setValue, submit } = useFormControls<FormValues>({
        defaultValues,
        onSubmit: submitHandler,
        resolver,
    });

    return {
        renderFormContent,
        setValue,
        submit,
    };
};
